import { render, staticRenderFns } from "./StatisticsByTest.vue?vue&type=template&id=8556e560&scoped=true"
import script from "./StatisticsByTest.vue?vue&type=script&lang=js"
export * from "./StatisticsByTest.vue?vue&type=script&lang=js"
import style0 from "./StatisticsByTest.vue?vue&type=style&index=0&id=8556e560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8556e560",
  null
  
)

export default component.exports